export const getPageModel = (pageModels, id) => pageModels[id]

export const getTranslation = (translations, alias) => {
  var translation = translations[alias]
  if (translation) {
    return translation
  }
  return `-- ${alias} missing translation --`
}
